// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-update-reports-button] {
    --md-outlined-icon-button-icon-size: 20px;
    height: 30px;
    width: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/TabsLayout/components/UpdateReportsComponent/UpdateReportsComponent.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,YAAY;IACZ,WAAW;AACf","sourcesContent":["[data-update-reports-button] {\n    --md-outlined-icon-button-icon-size: 20px;\n    height: 30px;\n    width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
